// Bundled fallback list of models for the editor palette. The live library
// comes from the backend (GET /models) and supersedes this at runtime; this
// list only shows if the backend is unreachable, so the palette never breaks.
//
// Uploaded models live in the database (the ModelAsset registry) and are served
// from object storage (Cloudflare R2) via ASSETS_PUBLIC_BASE; the frontend just
// reads whatever the registry returns. Categories group the palette; a default
// behavior makes an asset game-ready on drop (e.g. a Coin arrives Collectible).
//
// SIZING — 1 unit ≈ 1 metre; set fitHeight (target height in units) and the
// engine auto-scales on load. character ≈ 1.8 · tree ≈ 4 · crate ≈ 1.

export type AssetCategory =
  | 'Characters'
  | 'Environment'
  | 'Structures'
  | 'Props'
  | 'Collectibles'
  | 'Primitives'
  | 'Other';

export interface ModelAsset {
  id: string;
  label: string;
  src: string;
  category?: AssetCategory | string;
  defaultBehavior?: string; // player | collectible | goal | obstacle | hazard
  fitHeight?: number;
  scale?: number;
}

export const MODEL_ASSETS: ModelAsset[] = [
  { id: 'character', label: 'Character', src: '/models/character.glb', category: 'Characters', defaultBehavior: 'player', fitHeight: 1.8 },
  { id: 'tree', label: 'Tree', src: '/models/tree.glb', category: 'Environment', fitHeight: 4 },
  { id: 'crate', label: 'Crate', src: '/models/crate.glb', category: 'Props', defaultBehavior: 'obstacle', fitHeight: 1 },
];

export function getModelAsset(id: string): ModelAsset | undefined {
  return MODEL_ASSETS.find((m) => m.id === id);
}
